import { render, staticRenderFns } from "./index copy.vue?vue&type=template&id=3d0823b1&scoped=true"
import script from "./index copy.vue?vue&type=script&lang=js"
export * from "./index copy.vue?vue&type=script&lang=js"
import style0 from "./index copy.vue?vue&type=style&index=0&id=3d0823b1&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0823b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d0823b1')) {
      api.createRecord('3d0823b1', component.options)
    } else {
      api.reload('3d0823b1', component.options)
    }
    module.hot.accept("./index copy.vue?vue&type=template&id=3d0823b1&scoped=true", function () {
      api.rerender('3d0823b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/bjlogin/index copy.vue"
export default component.exports